import { useEffect, useState } from "react";

// Busted in a cash game: RE-BUY? with the seconds left before the seat is released (server clock, REBUY_WINDOW_MS after the result).
export const RebuyButton = ({ my, serverNow, onClick }) => {
  const [left, setLeft] = useState(null);
  useEffect(() => {
    if (!my.sit_out_until) { setLeft(null); return; }
    const tick = () => setLeft(Math.max(0, Math.ceil((my.sit_out_until - serverNow()) / 1000)));
    tick();
    const id = setInterval(tick, 250);
    return () => clearInterval(id);
  }, [my.sit_out_until, serverNow]);
  return (
    <button data-testid="rebuy-button" onClick={onClick} className="rounded-full px-6 py-3 text-sm font-display tracking-wider bg-amber-500 text-slate-900 btn-lift self-center animate-pulse flex items-center gap-2">
      RE-BUY?
      {left != null && <span data-testid="rebuy-countdown" className={`font-mono text-xs rounded-full px-2 py-0.5 ${left <= 10 ? "bg-red-700 text-white" : "bg-slate-900/80 text-amber-200"}`}>{left}s</span>}
    </button>
  );
};
